import React from 'react';
import { DotsContainer, DotsLoader, DotOne, DotTwo, DotThree } from './DotsLoader.styles';

interface Props {
  rightSide: boolean;
  dataQaId?: string;
}

const DotsLoaderFC: React.FC<Props> = ({ rightSide, dataQaId }) => (
  <DotsContainer position={rightSide} data-qa-id={dataQaId}>
    <DotsLoader>
      <DotOne />
      <DotTwo />
      <DotThree />
    </DotsLoader>
  </DotsContainer>
);

export default DotsLoaderFC;
